/**
 * Generated API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const FileStatus = {
    PendingScan: 'PENDING_SCAN',
    Clean: 'CLEAN',
    Infected: 'INFECTED',
    PendingAnalysis: 'PENDING_ANALYSIS',
    AnalysisComplete: 'ANALYSIS_COMPLETE',
    Uploading: 'UPLOADING',
    FailedScan: 'FAILED_SCAN',
    AnalysisFailed: 'ANALYSIS_FAILED'
} as const;
export type FileStatus = typeof FileStatus[keyof typeof FileStatus];

